<template>
  <div class="ai-card" :class="{ 'ai-card--mobile': isMobile }" :style="style">
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { PropType, computed } from 'vue';

import { useCommonStore } from '@/store/common';
import { storeToRefs } from 'pinia';

const props = defineProps({
  radius: {
    type: Number as PropType<number>,
    required: false,
  },
});

const { isMobile } = storeToRefs(useCommonStore());

const style = computed(() => {
  const result: any = {};
  if (props.radius) {
    result['border-radius'] = `${props.radius}px`;
  }
  return result;
});
</script>

<style lang="scss" src="./AiCard.scss" />
